import React, { useEffect, useState, useLayoutEffect } from "react";
// import ReactHtmlParser, {
//   processNodes,
//   convertNodeToElement,
//   htmlparser2,
// } from "react-html-parser";
import parse from "html-react-parser";
import { QRCodeSVG } from "qrcode.react";

import logoLight from "../../assets/images/logo-light.png";
import moment from "moment";
import { api } from "../../config";
import PrintComponent from "../../Components/Common/PrintComponent";

const PrintDoc = ({ innerRef, item }) => {
  const [nums, setNums] = useState("");
  const [desc, setDesc] = useState("");
  const [logo, setLogo] = useState();
  const [signed, setSigned] = useState();

  // useEffect(() => {
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   if (obj) {
  //     setDataUser(obj);
  //   }
  // }, []);

  const numRoman = (num) => {
    if (num === "1") {
      return "I";
    } else if (num === "2") {
      return "II";
    } else if (num === "3") {
      return "III";
    } else if (num === "4") {
      return "IV";
    } else if (num === "5") {
      return "V";
    } else if (num === "6") {
      return "VI";
    } else if (num === "7") {
      return "VII";
    } else if (num === "8") {
      return "VIII";
    } else if (num === "9") {
      return "IX";
    } else if (num === "10") {
      return "X";
    } else if (num === "11") {
      return "XI";
    } else if (num === "12") {
      return "XII";
    }
  };

  useEffect(() => {
    if (item.sik) {
      const desc = item.sik.description
        .replaceAll(
          "[service]",
          `<b>${item.data.task_service ? item.data.task_service.name : ""}</b>`
        )
        .replaceAll(
          "[campaignPage]",
          `${(item.data.task_campaignPage || []).map((el, i) => {
            return `<span key=${i}>${el.task_campaignPage_campaignPage.name} </span>`;
          })}`
        )
        .replaceAll("[taskname]", `<h6>${item.data ? item.data.name : ""}</h6>`)
        .replaceAll(
          "[prefix]",
          `<b>${item.prefix
            ? item.prefix +
            "/" +
            numRoman(moment().format("M")) +
            "/" +
            moment().format("YYYY")
            : ""
          }</b>`
        )
        .replaceAll("[dashed]", `<hr/>`)
        .replaceAll("<p></p>", `<br/>`)
        .replaceAll(
          "[branch]",
          `<b>${item.data.task_branch ? item.data.task_branch.name : ""}</b>`
        )
        .replaceAll(
          "[company]",
          `<b>${item.data.task_company ? item.data.task_company.name : ""}</b>`
        )
        .replaceAll(
          "[task description]",
          `${item.data.description ? item.data.description : ""}`
        )
        .replaceAll(
          "[unit]",
          `${(item.data.task_unit || []).map((el, i) => {
            return `<span key=${i}>${el.task_unit_unit.name} </span>`;
          })}`
        )
        .replaceAll(
          "[print date]",
          `${moment().format("DD MMMM YYYY")}`
        )
        .replaceAll(
          "[task periode]",
          `${moment(item.data.startat)

            .format("DD MMMM YYYY")} - ${moment(item.data.endat)

              .format("DD MMMM YYYY")}`
        )
        .replaceAll(
          "[assignto]",
          `<table className='table table-striped'>
        <thead>
          <tr className='table-dark'>
            <th scope='col'>No</th>
            <th scope='col'>Nama</th>
            <th scope='col'>No HP</th>
            <th scope='col'>NIK</th>
            <th scope='col'>Fungsi</th>
          </tr>
        </thead>
        <tbody>
          ${item.data.task_assign.map((el, i) => {
            return `
              <tr key={${i}}>
                <th scope='row'>${i + 1}</th>
                <td>
                  ${el.taska_user.user_employee
                ? el.taska_user.user_employee.name
                : "-"
              }
                </td>
                <td>
                ${el.taska_user.phone ? el.taska_user.phone : "-"}
                </td>
                <td>
                  ${el.taska_user.user_employee.code
                ? el.taska_user.user_employee.code
                : "-"
              }
                </td>
                <td>
                  ${el.taska_user.user_position
                ? el.taska_user.user_position.name
                : "-"
              }
                </td>
              </tr>`;
          })}
        </tbody>
      </table>`
        )
        .replaceAll(
          "[print user]",
          `${item.data.task_report.map((el, i) => {
            let admin;
            if (el.isAdmin) {
              admin = el;
            }
            return `${admin ? admin.taskr_user.name : ""}`;
          })}`
        )
        .replaceAll(
          "[user position]",
          `${item.data.task_report.map((el, i) => {
            let admin;
            if (el.isAdmin) {
              admin = el;
            }
            return `<span key=${i}>${admin ? admin.taskr_user.user_position.name : ""
              } </span>`;
          })}`
        )
        .replaceAll(
          "[branch address]",
          `${(
            (item.data.task_branch && item.data.task_branch.branch_address) ||
            []
          ).map((el, i) => {
            return `<span key=${i}>${el.task_branch_address.name} </span>`;
          })}`
        )
        .replaceAll("[to]", `${item.to ? item.to : ""}`);
      setDesc(parse(desc));
    }
    if (item.data.task_report) {
      let imageSign;
      item.data.task_report.forEach((el) => {
        let admin;
        if (el.isAdmin) {
          admin = el;
        }
        if (admin) {
          imageSign =
            api.MEDIA_URL +
            "/media/" +
            admin.taskr_user.user_employee.imageSigned;
        }
      });
      setLogo(imageSign);
      setSigned(imageSign);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  if (item.data) {
    return (
      <div
        className='d-none'
        style={{
          overflow: "scroll",
          //backgroundColor: "blue"
        }}>
        <div
          ref={innerRef}
          className='bg-white'
          style={{
            paddingLeft: "80px",
            paddingRight: "80px",
          }}>
          <div className='d-flex justify-content-end'>
            {item.data?.task_client.client_image ? (
              <img
                alt=''
                src={
                  process.env.REACT_APP_API_URL +
                  "/media/" +
                  item.data?.task_client.client_image?.file_folder.name +
                  "/" +
                  item.data?.task_client.client_image?.filename
                }
                style={{ maxWidth: "150px", maxHeight: "50px" }}/>
            ) : null}
          </div>
          <div>
            <PrintComponent item={item}>
              <div>{desc ? desc : "-"}</div>
              <div className='d-flex justify-content-end align-items-right'>
                <div className='d-flex justify-content-end mb-4'>
                  <QRCodeSVG
                    value={"asdfasdf"}
                    size={70}
                    imageSettings={{ src: logo, excavate: true }}/>
                </div>
              </div>
            </PrintComponent>
          </div>
          <div className='pagebreak'>
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <PrintComponent item={item}>
            <div
              // ref={innerRef}
              className='bg-white'
              style={{ padding: "1px 2px 1px 2px" }}>
              <table className='table table-striped mb-3'>
                <thead>
                  <tr className='table-dark'>
                    <th scope='col'>No</th>
                    <th scope='col'>Nama</th>
                    <th scope='col' width={400}>
                      KTP
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item.data.task_assign.map((el, i) => {
                    return (
                      <tr key={i}>
                        <th scope='row'>{i + 1}</th>
                        <td>
                          {el.taska_user.user_employee
                            ? el.taska_user.user_employee.name
                            : "-"}
                        </td>
                        <td>
                          {el.taska_user.user_employee.imageKTP ? (
                            <img
                              src={
                                el.taska_user.user_employee
                                  ? api.MEDIA_URL +
                                  "/media/" +
                                  el.taska_user.user_employee.imageKTP
                                  : null
                              }
                              alt=''
                              style={{ maxWidth: "200px" }} />
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </PrintComponent>
          <div className='pagebreak'>
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <PrintComponent item={item}>
            <div
              // ref={innerRef}
              className='bg-white'
              style={{ padding: "1px 2px 1px 2px" }}>
              <table className='table table-striped mb-3'>
                <thead>
                  <tr className='table-dark'>
                    <th scope='col'>No</th>
                    <th scope='col'>Nama</th>
                    <th scope='col' width={400}>
                      KTP
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item.data.task_assign.map((el, i) => {
                    return (
                      <tr key={i}>
                        <th scope='row'>{i + 1}</th>
                        <td>
                          {el.taska_user.user_employee
                            ? el.taska_user.user_employee.name
                            : "-"}
                        </td>
                        <td>
                          {el.taska_user.user_employee.imageHealth ? (
                            <img
                              src={
                                el.taska_user.user_employee
                                  ? api.MEDIA_URL +
                                  "/media/" +
                                  el.taska_user.user_employee.imageHealth
                                  : null
                              }
                              alt=''
                              style={{ maxWidth: "200px" }} />
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </PrintComponent>
          <div className='pagebreak'>
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <PrintComponent item={item}>
            <div
              // ref={innerRef}
              className='bg-white'
              style={{ padding: "1px 2px 1px 2px" }}>
              <table className='table table-striped mb-3'>
                <thead>
                  <tr className='table-dark'>
                    <th scope='col'>No</th>
                    <th scope='col'>Nama</th>
                    <th scope='col' width={400}>
                      KTP
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item.data.task_assign.map((el, i) => {
                    return (
                      <tr key={i}>
                        <th scope='row'>{i + 1}</th>
                        <td>
                          {el.taska_user.user_employee
                            ? el.taska_user.user_employee.name
                            : "-"}
                        </td>
                        <td>
                          {el.taska_user.user_employee.imageVaksin ? (
                            <img
                              src={
                                el.taska_user.user_employee
                                  ? api.MEDIA_URL +
                                  "/media/" +
                                  el.taska_user.user_employee.imageVaksin
                                  : null
                              }
                              alt=''
                              style={{ maxWidth: "200px" }} />
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </PrintComponent>
        </div>
      </div>
    );
  }
};

export default PrintDoc;
